module.exports = __webpack_public_path__ + "img/pic_ghost.e9d92333.gif";